import { Form } from "antd";
import GenericFormItem from "./GenericFormItem";
import React, { Component } from "react";

class GenericForm extends Component {

    render() {
        let columnCount = window.innerWidth > 600 && this.props.columnCount ? this.props.columnCount : '1'
        return (<Form style={{ columnWidth: "auto", columnCount }}>
            {this.props.fields.map(x => {
                return (<GenericFormItem  {...x}
                    value={this.props.value[x.key]}
                    onChange={e => { this.props.onChange({ [x.key]: e }) }}
                />)
            })}
        </Form>)
    }
}

export default GenericForm;